import { RouteObject } from "react-router-dom";

export const orderEditingRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Order editing" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { OrderEditingPage } = await import("./OrderEditingPage");
          return { Component: OrderEditingPage };
        },
      },
    ],
  },
];
